import React from "react";
import { useOnboarding } from "../contexts/OnboardingContext";
import {
  ROLE_TYPES,
  STEP_IDS,
  ONBOARDING_FLOWS,
} from "../constants/onboardingSteps";
import TrustForward from "./OnboardingLayout/TrustForward.tsx";
import SocialProof from "./OnboardingLayout/SocialProof.jsx";
import ProductPreview from "./OnboardingLayout/ProductPreview.jsx";

const OnboardingLayout = ({
  children,
  title,
  subtitle,
  showStepIndicator = true,
}) => {
  const { currentStep } = useOnboarding();

  // Single carrier flow is always used
  const activeFlow = ONBOARDING_FLOWS[ROLE_TYPES.CARRIER];

  // Clamp currentStep to the bounds of the configured flow so we never read past the array.
  const clampedStepIndex = Math.min(currentStep, activeFlow.length - 1);
  const currentStepId = activeFlow[clampedStepIndex];

  // Progress indicator values are derived from the flow configuration:
  // "Step N of M" where:
  // - N is the 1-based index of the current step in the active flow
  // - M is the total number of steps for that flow
  const displayStepNumber = clampedStepIndex + 1;
  const totalDisplaySteps = activeFlow.length;

  // Get step-specific marketing content based on the logical step id
  const getStepContent = () => {
    switch (currentStepId) {
      case STEP_IDS.BASIC_INFO:
        return <TrustForward />;

      case STEP_IDS.AUTHORITY:
        return <SocialProof />;

      case STEP_IDS.TRUCKSTOP:
        return <ProductPreview />;

      case STEP_IDS.SUMMARY:
      default:
        return <TrustForward />;
    }
  };

  // const stepContent = getStepContent();

  // const renderRightContent = () => {
  //   switch (tab) {
  //     case 1:
  //       return <TrustForward />;
  //     case 2:
  //       return <SocialProof />;
  //     case 3:
  //       return <ProductPreview />;
  //     default:
  //       return <TrustForward />;
  //   }
  // };

  return (
    <div className="min-h-screen bg-white">
      <div className="flex h-screen">
        <div className="flex-1 bg-white overflow-hidden flex flex-col">
          <div className="flex-1 overflow-y-auto flex justify-center items-center">
            <div className="max-w-2xl mx-auto px-6 py-8 md:px-8 md:py-12">
              {/* Progress Indicator - Segmented style for all steps */}
              {showStepIndicator && (
                <div className="mb-8">
                  <p className="text-xs uppercase tracking-wider text-gray-400 mb-3">
                    Step {displayStepNumber} of {totalDisplaySteps}
                  </p>
                  <div className="flex gap-2">
                    {Array.from({ length: totalDisplaySteps }, (_, index) => (
                      <div
                        key={index}
                        className={`h-1 w-24 rounded-full ${
                          index < displayStepNumber
                            ? "bg-blue-500"
                            : "bg-gray-100"
                        }`}
                      />
                    ))}
                  </div>
                </div>
              )}

              {title && (
                <div className="mb-8 text-start">
                  <h1 className="text-3xl md:text-4xl font-medium text-gray-900 mb-2">
                    {title}
                  </h1>
                  {subtitle && (
                    <p className="text-base md:text-lg text-gray-600">
                      {subtitle}
                    </p>
                  )}
                </div>
              )}

              <div className="onboarding-form-content flex flex-col items-center">
                <div className="w-full max-w-md">{children}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Panel - Marketing/Benefits */}
        <div className="hidden lg:flex lg:w-1/2 bg-[linear-gradient(165deg,#0a1628_0%,#0f2847_50%,#0a1628_100%)] flex-col justify-center items-center px-8 py-12">
          <div className="max-w-md h-full flex justify-center items-center">
            <div className="">{getStepContent()}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingLayout;
